<template>
    <div style="width: 100%">
        <h2>{{ item.title }}</h2>
        <div v-for="child in item.children">
            <h3 v-if="child.title">{{ child.title }}</h3>
            <div class="white">
                <div v-for="content in child.contents" style="width: 100%">
                    <p v-if="child.type==='name'">
                        <span class="name-box" :class="{two_l:content[0].length<3}">{{ content[0] }}</span>：{{ content[1] }}
                    </p>
                    <p v-else>{{ content }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: "item",
	props: {
		item: {
			type: Object,
			default: () => {
			}
		}
	}
}
</script>

<style scoped>
.name-box {
    display: inline-block;
    width: 8.4rem;
    text-align: center;

}

.two_l {
    letter-spacing: 1.4rem;
}
</style>
